import { UserTypes, UserActions } from './user.actions';

export let initialState = null;

export function reducer(state = initialState, action: UserActions): object {
  switch (action.type) {
    case UserTypes.SET_USER:
      return { ...action.payload };
    case UserTypes.SET_USER_INFO:
      return { state, ...action.payload };
    default:
      return state;
  }
}
